module.exports = __webpack_public_path__ + "static/media/atuacao-002.1b523fc1.jpg";